import { render, staticRenderFns } from "./courseDescription.vue?vue&type=template&id=d3112a30&scoped=true&"
import script from "./courseDescription.vue?vue&type=script&lang=js&"
export * from "./courseDescription.vue?vue&type=script&lang=js&"
import style0 from "./courseDescription.vue?vue&type=style&index=0&id=d3112a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3112a30",
  null
  
)

export default component.exports